var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import jwt_decode from 'jwt-decode';
import { trackEvent } from '@raisin/events-tracking';
import store from 'store2';
import { keycloakLogout, logout } from '../../api/services';
import { LocalStorageKey } from '../../enums';
import { createLogOutSucceededEvent, EVENTS } from '../../eventsTracking';
import { getRefreshToken, getUnixTime, isCSR, isLocalEnv } from '../index';
import { goToLoginPage } from '../navigation';
import { cleanUpSessionData } from '../sessionCleanup';
import { refreshTokenPostCall } from './api/authApi';
export const logOutTheCustomer = ({ userManagementCallObsLogout, umtFECallKeycloakLogoutOnSessionTimeout, platform, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const refreshToken = getRefreshToken();
        if (umtFECallKeycloakLogoutOnSessionTimeout && refreshToken) {
            yield keycloakLogout(refreshToken);
        }
        if (userManagementCallObsLogout) {
            yield logout();
        }
        trackEvent(createLogOutSucceededEvent({ zone: platform }), true);
    }
    catch (e) {
        if (e instanceof Error) {
            throw new Error(e.message);
        }
    }
    finally {
        cleanUpSessionData();
        if (isCSR()) {
            goToLoginPage();
        }
    }
});
export const getKeycloakToken = () => {
    const keyCloakTokenObj = isCSR() ? store(LocalStorageKey.AUTH_TOKEN) : null;
    const keyCloakAccessToken = keyCloakTokenObj ? keyCloakTokenObj.access_token : null;
    const keyCloakRefreshToken = keyCloakTokenObj ? keyCloakTokenObj.refresh_token : null;
    return { keyCloakTokenObj, keyCloakRefreshToken, keyCloakAccessToken };
};
export const refreshJWT = ({ userManagementCallObsLogout, umtFECallKeycloakLogoutOnSessionTimeout, platform, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (isLocalEnv()) {
        setTimeout(() => Promise.resolve(), 500);
        return;
    }
    const { keyCloakTokenObj, keyCloakRefreshToken, keyCloakAccessToken } = getKeycloakToken();
    if (keyCloakAccessToken && keyCloakRefreshToken) {
        const { exp, azp } = jwt_decode(keyCloakAccessToken);
        const timeDiff = (_a = store(LocalStorageKey.AUTH_TIME_DIFF)) !== null && _a !== void 0 ? _a : 0;
        if (exp < getUnixTime(-timeDiff)) {
            trackEvent(EVENTS.REFRESH_TOKEN_EXPIRED, true);
            yield logOutTheCustomer({
                userManagementCallObsLogout,
                umtFECallKeycloakLogoutOnSessionTimeout,
                platform,
            });
            throw new Error('Refresh token expired!');
        }
        try {
            const res = yield refreshTokenPostCall(keyCloakRefreshToken, azp);
            store(LocalStorageKey.AUTH_TOKEN, Object.assign(Object.assign({}, keyCloakTokenObj), { access_token: res.data.access_token, refresh_token: res.data.refresh_token }));
            const { iat } = jwt_decode(res.data.access_token);
            const timeDiff = getUnixTime(-iat);
            store(LocalStorageKey.AUTH_TIME_DIFF, timeDiff);
            trackEvent(EVENTS.REFRESH_TOKEN_SUCCEEDED, true);
        }
        catch (e) {
            trackEvent(EVENTS.REFRESH_TOKEN_FAILED, true);
            yield logOutTheCustomer({
                userManagementCallObsLogout,
                umtFECallKeycloakLogoutOnSessionTimeout,
                platform,
            });
            throw new Error('Refresh token failed!');
        }
    }
});
//# sourceMappingURL=index.js.map